import { Theme } from '@material-ui/core/styles';

export const getMuiCssBaseline = (theme: Theme): Record<string, unknown> => ({
  MuiCssBaseline: {
    '@global': {
      '*': {
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
      },

      body: {
        backgroundColor: theme.palette.common.white,
        color: 'inherit',
        fontSize: theme.typography.fontSize,
        margin: 0,
        padding: 0,
      },

      textarea: {
        minHeight: 'unset',
      },

      h2: {
        color: 'unset',
      },

      '#flipdish-budapest a': {
        color: 'unset',
      },
      '#flipdish-budapest ul': {
        listStyleType: 'none',
        padding: 'unset',
      },

      'a:hover': {
        color: 'unset',
      },

      'textarea:focus': {
        boxShadow: 'none',
      },
      'input:focus': {
        boxShadow: 'none',
      },
      'input[type]:focus': {
        boxShadow: 'none',
      },
      '.uneditable-input:focus': {
        boxShadow: 'none',
      },

      '.container': {
        all: 'unset',
        width: '100%',

        '&.no-margin': {
          all: 'unset',
        },
      },

      '.row': {
        all: 'unset',
        width: '100%',
      },

      '.section': {
        all: 'unset',

        '&.menu1.mymenu': {
          marginBottom: 'unset',
        },

        '& #footer': {
          overflow: 'unset',
        },

        '& .full-width': {
          paddingTop: 'unset',
          width: 'unset',

          '& .row': {
            marginLeft: 'unset',
            marginRight: 'unset',
          },
        },

        '&.dark': {
          background: 'unset',

          '& h2': {
            color: 'unset',
          },

          '& input[type="text"], & input[type="email"]': {
            all: 'unset',
          },

          '& textarea': {
            all: 'unset',
          },
        },
      },

      [`@media (max-width: 767px)`]: {
        '.container': {
          all: 'unset',
        },

        '.section': {
          all: 'unset',
        },
      },
      [`@media (min-width: 768px)`]: {
        '.container': {
          all: 'unset',
        },

        '.section': {
          all: 'unset',
        },
      },
      [`@media (max-width: 990px)`]: {
        '.container': {
          all: 'unset',
        },

        '.section': {
          all: 'unset',
        },
      },
      [`@media (max-width: 1024px)`]: {
        '.container': {
          all: 'unset',
        },

        '.section': {
          all: 'unset',
        },
      },
    },
  },
});
